import { useState } from 'react';

import clsx from 'clsx';

import { Button, Typography } from 'darrius';

import { sha256 } from '../../../utils/sha256';

import { Step } from '../../../components';
import { PasswordField } from '../../../components/molecules/PasswordField/PasswordField';

import styles from './CreatePassword.module.scss';

export const CreatePassword = ({ onButtonClick, isButtonLoading }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const errorMessage =
    password.length > 0 && confirmPassword.length > 0
      ? password === confirmPassword
        ? ''
        : 'As senhas não correspondem'
      : '';

  const isButtonDisabled = !(
    password.length > 0 &&
    confirmPassword.length > 0 &&
    password === confirmPassword
  );

  const validations = {
    minLength: password.length >= 8,
    hasNumbers: /\d+/.test(password),
    hasUpperCase: /[A-Z]/.test(password),
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  function handleHashPassword(passwordValue: string) {
    const hashPassword = sha256(passwordValue);

    onButtonClick(hashPassword);
  }

  return (
    <Step.Root>
      <Step.Header>
        <Typography.Subtitle
          size="xl"
          className={`spacing-stack-bottom-300 ${styles['password-title']}`}
        >
          Cadastre sua nova senha
        </Typography.Subtitle>
      </Step.Header>
      <Step.Body>
        <PasswordField
          className="spacing-stack-bottom-300"
          id="id"
          name="password"
          label="Nova senha"
          placeholder="Digite sua senha"
          onChange={handlePasswordChange}
          onBlur={handlePasswordChange}
          value={password}
          errorMessage=""
        />
        <PasswordField
          className="spacing-stack-bottom-300"
          id="id"
          name="new-password"
          label="Confirme a nova senha"
          placeholder="Confirme sua senha"
          onChange={handleConfirmPasswordChange}
          onBlur={handleConfirmPasswordChange}
          value={confirmPassword}
          errorMessage={errorMessage}
        />
        <section>
          <Typography.Text
            className={`spacing-stack-bottom-300 ${styles['validations-title']}`}
          >
            Sua senha deve ter:
          </Typography.Text>
          <ul className={styles['validations']}>
            <li
              className={clsx({
                'spacing-stack-bottom-300': true,
                [styles['validation']]: true,
                [styles['validation--is-valid']]: validations.minLength,
              })}
            >
              Mínimo de 8 caracteres
            </li>
            <li
              className={clsx({
                'spacing-stack-bottom-300': true,
                [styles['validation']]: true,
                [styles['validation--is-valid']]: validations.hasNumbers,
              })}
            >
              Conter números
            </li>
            <li
              className={clsx({
                'spacing-stack-bottom-300': true,
                [styles['validation']]: true,
                [styles['validation--is-valid']]: validations.hasUpperCase,
              })}
            >
              Uma letra maiúscula
            </li>
          </ul>
        </section>
        <Step.Actions>
          <Button.Root
            type="button"
            fullWidth
            disabled={isButtonDisabled}
            isLoading={isButtonLoading}
            onClick={() => handleHashPassword(password)}
            className="spacing-stack-bottom-100"
          >
            Continuar
          </Button.Root>
        </Step.Actions>
      </Step.Body>
    </Step.Root>
  );
};
